export default import.meta.ROLLDOWN_FILE_URL_RdUDfm8_NijmX6SuNoEgmw